import React, { useContext } from 'react'
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material'
import moment from 'moment'
import { Form } from 'react-final-form'
import { TextField } from 'mui-rff'
import { usePatchStaffBenefit } from '../../api/staff-benefit'
import { useSnackbar } from 'notistack'
import { StaffBenefitContext } from './StaffBenefitTable'

export const EditEndDateDialog = (props) => {
  const { openEditDate, onClose, row } = props
  const { mutateAsync, isLoading } = usePatchStaffBenefit()
  const { enqueueSnackbar } = useSnackbar()
  const { refetch } = useContext(StaffBenefitContext)

  const handleCancel = () => {
    onClose()
  }

  const onSubmit = async (values) => {
    const startingDate = moment(row.startDate)
    const endingDate = moment(values.endDate)

    if (endingDate.isSameOrAfter(startingDate)) {
      const res = await mutateAsync({
        ...values,
        staffBenefitId: row.id,
      }).catch((e) => {
        if (e?.response?.data?.errors) {
          enqueueSnackbar(e?.response?.data?.errors[0]?.msg, {
            variant: 'error',
          })
        } else {
          enqueueSnackbar(e?.response?.data?.message ?? 'Fail to update end date', {
            variant: 'error',
          })
        }
      })
      if (res?.status === 200) {
        enqueueSnackbar('Ending Date is updated', {
          variant: 'success',
        })
        refetch()
        onClose()
      }
    } else {
      enqueueSnackbar('End date should be after the start date', {
        variant: 'error',
      })
    }
  }

  const validate = (values) => {
    const errors = {}
    const startDate = moment(row.startDate)
    const endDate = moment(values.endDate)
    if (!endDate.isValid()) {
      errors.endDate = 'Date input is invalid'
    } else if (endDate.isBefore(startDate)) {
      errors.endDate = 'End Date must be after Start Date'
    }
    return errors
  }

  return (
    <Form
      onSubmit={onSubmit}
      validate={validate}
      keepDirtyOnReinitialize //let data stay on the form
      initialValues={{ endDate: moment(row.endDate).format('YYYY-MM-DD') }}
      component={({ handleSubmit, submitting }) => (
        <Dialog maxWidth='sm' open={openEditDate}>
          <form onSubmit={handleSubmit}>
            <DialogTitle id='edit-endDate-title'>Edit Ending Date ({row.name})</DialogTitle>
            <DialogContent dividers>
              <Box
                display='flex'
                flexDirection='column'
                minHeight={100}
                justifyContent='space-between'
              >
                {row.startDate && (
                  <Typography>Starting Date: {moment(row.startDate).format('D/M/YYYY')}</Typography>
                )}
                <TextField
                  label='End Date'
                  type='date'
                  name='endDate'
                  margin='none'
                  placeholder='yyyy-mm-dd'
                />
              </Box>
            </DialogContent>
            <DialogActions>
              <Button variant='outlined' onClick={handleCancel}>
                Cancel
              </Button>
              <Button
                color='primary'
                variant='contained'
                type='submit'
                disabled={submitting || isLoading}
              >
                {isLoading && <CircularProgress size='1rem' />}
                Save
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      )}
    />
  )
}
